import './ConsumerProfile.scss';

export interface ConsumerDetails {
  username: string;
  percent: number;
  status: string;
  progress: number;
}

interface Props {
  consumerProfileDetails: ConsumerDetails[];
}

function ConsumerProfile({ consumerProfileDetails }: Props) {
  const segmentsPerRow = 5;

  const sortedDetails = [...consumerProfileDetails].sort((a, b) => b.percent - a.percent);

  const totalRows = Math.ceil(sortedDetails.length / segmentsPerRow);

  return (
    <div className="consumer-profile">
      {[...Array(totalRows)].map((_, rowIndex) => {
        const rowUsers = sortedDetails.slice(
          rowIndex * segmentsPerRow,
          rowIndex * segmentsPerRow + segmentsPerRow
        );
        const segmentsInRow = rowUsers.length;

        return (
          <div key={rowIndex} className="consumer-profile__row">
            {rowUsers.map((user, i) => (
              <div key={i} className="consumer-profile__profile-details">
                <div className="consumer-profile__profile-details__username">{user.username}</div>
                <div className="consumer-profile__profile-details__percent">{user.percent}%</div>
                <div className="consumer-profile__profile-details__status">{user.status}</div>
                <div className="consumer-profile__profile-details__progress-bar">
                  {[...Array(10)].map((_, idx) => (
                    <div
                      key={idx}
                      className="consumer-profile__profile-details__progress-bar__segment"
                      style={{
                        backgroundColor:
                          idx < Math.round(user.progress / 10) ? '#00660A' : '#8F8F8F'
                      }}
                    />
                  ))}
                </div>
              </div>
            ))}
            {[...Array(segmentsInRow - 1)].map((_, i) => {
              const left = (100 / segmentsInRow) * (i + 1);
              return (
                <div
                  key={i}
                  className="consumer-profile__vertical-divider"
                  style={{ left: `${left}%` }}
                />
              );
            })}
            {rowIndex < totalRows - 1 && <div className="consumer-profile__row-divider" />}
          </div>
        );
      })}
    </div>
  );
}

export default ConsumerProfile;
